<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="496"
    >
      <v-card>
        <v-card-title class="d-flex justify-end">
          <v-btn
            icon
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-15">
          <v-card-text>
            <div class="subtitle-1">{{ $t('forYouOpeningTxt.intro') }}</div>
          </v-card-text>
          <v-card-text>
            <div class="d-flex align-center pb-2">
              <v-icon left size="16">mdi-gift-outline</v-icon>
              <div class="font-weight-bold">
                {{ $t('forYouOpeningTxt.howToWinFreeSpins') }}
              </div>
            </div>
            <div v-html="$t('forYouOpeningTxt.development')"></div>
          </v-card-text>
          <v-card-text class="pb-0">
            {{ $t("forYouOpeningTxt.conclusion") }}
          </v-card-text>
        </v-card-text>


        <v-card-actions
          class="pb-4 pt-15 px-5"
        >
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            block
            @click="close()"
          >
            {{ $t("gotIt") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
    }),

    computed: {
      isFirstTime() {
        return this.$store.state.dialogGreetingsPromotionsFirstTime;
      }
    },

    mounted() {
      this.isFirstTime && this.open();
    },
    watch: {
      dialog(val) {
        if (!val) {
          this.close();
        }
      },
    },
    methods: {
      open() {
        this.dialog = true;
      },
      close() {
        this.$store.commit("showDialogGreetingsPromotionsFirstTime", false)
        this.dialog = false;
      }
    }
  }

</script>